import React from 'react';
import { Button } from './ui/button';
import { Code2, Cloud, Database, Shield, Smartphone, Cpu } from 'lucide-react';

const SoftwareHighlight = () => {
  const services = [
    { icon: Code2, text: 'Web & Mobile Development' },
    { icon: Cloud, text: 'Cloud Solutions' },
    { icon: Database, text: 'Data Engineering' },
    { icon: Shield, text: 'Cybersecurity' },
    { icon: Smartphone, text: 'Mobile Apps' },
    { icon: Cpu, text: 'AI & ML Solutions' },
  ];

  return (
    <section id="software" className="py-20 px-4 sm:px-6 lg:px-8 bg-[#111827]">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Services List */}
          <div className="space-y-8">
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold mb-4 font-['Space_Grotesk']">
                Software & <span className="bg-gradient-to-r from-[#00E5FF] to-[#1DE9B6] bg-clip-text text-transparent">IT Services</span>
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-[#00E5FF] to-transparent mb-4"></div>
              <p className="text-xl text-[#9CA3AF]">
                Cutting-edge technology solutions for modern enterprises
              </p>
            </div>

            <div className="grid grid-cols-2 gap-6">
              {services.map((service, index) => {
                const Icon = service.icon;
                return (
                  <div key={index} className="flex items-center space-x-3 group">
                    <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[#00E5FF] to-[#1DE9B6] flex items-center justify-center group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-[#00E5FF]/50 transition-all duration-300">
                      <Icon className="w-6 h-6 text-[#0B0F1A]" />
                    </div>
                    <span className="text-[#F9FAFB] font-medium">{service.text}</span>
                  </div>
                );
              })}
            </div>

            <div className="pt-6">
              <Button
                onClick={() => {
                  const element = document.getElementById('footer');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="bg-[#00E5FF] hover:bg-[#1DE9B6] text-[#0B0F1A] font-semibold px-8 py-6 text-lg rounded-lg shadow-lg shadow-[#00E5FF]/40 hover:shadow-[#00E5FF]/60 transition-all duration-300"
              >
                Discuss Your Project
              </Button>
            </div>
          </div>

          {/* Right Side - Tech Illustration */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden border-2 border-[#00E5FF]/30 shadow-2xl shadow-[#00E5FF]/20 hover:shadow-[#00E5FF]/40 transition-all duration-500 hover:scale-105">
              <img
                src="https://images.unsplash.com/photo-1610563166150-b34df4f3bcd6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxzb2Z0d2FyZSUyMGRldmVsb3BtZW50fGVufDB8fHx8MTc3MDIwODM5Nnww&ixlib=rb-4.1.0&q=85"
                alt="Software Development"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-[#0B0F1A]/60 to-transparent"></div>
            </div>
            
            {/* Floating neon accents */}
            <div className="absolute -top-4 -right-4 w-20 h-20 bg-[#00E5FF] rounded-full blur-2xl opacity-40 animate-pulse"></div>
            <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-[#1DE9B6] rounded-full blur-2xl opacity-40 animate-pulse" style={{ animationDelay: '1s' }}></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SoftwareHighlight;
